import { SanitizedHtml } from 'framework/utils';
import { MessageContentType } from './messageTypes';

const getMessageContent = (content: MessageContentType) =>
  typeof content === 'string' ? <SanitizedHtml html={content} /> : content;

export default getMessageContent;
